import { Link, Typography } from 'material-hu';
import { Trans } from 'react-i18next';
import { useTranslation } from 'src/pages/authentication/i18n';

const TermsOfUseAndPrivacy = () => {
  const { t } = useTranslation();

  const termsOfUseLink = (
    <Link
      href="https://humand.co/es/terminos-de-uso/"
      target="_blank"
      rel="noopener"
      sx={{ textDecoration: 'none', fontWeight: 400 }}
    >
      Términos de uso
    </Link>
  );

  const privacyPolicyLink = (
    <Link
      href="https://humand.co/es/politica-de-privacidad/"
      target="_blank"
      rel="noopener"
      sx={{ textDecoration: 'none', fontWeight: 400 }}
    >
      Privacidad
    </Link>
  );

  return (
    <Typography
      color="textSecondary"
    >
      <small>
        <Trans
          i18nKey="TERMS_OF_USE_AND_PRIVACY"
          t={t}
        >
          Al ingresar, acepta nuestros
          {termsOfUseLink}
          y
          {privacyPolicyLink}
          .
        </Trans>
      </small>
    </Typography>
  );
};

export default TermsOfUseAndPrivacy;
